import APIService from "@/services/APIService.js";
import store from "@/store/store";

export const namespaced = true;

export const state = {
  fileList: [],
  mixType: "",
  elementList: [],
  trackName: "",
  trackCategory: "",
  trackStyle: "",
  trackProject: "",
  userName: "",
  reqReuplaod: false,
  trackUploadStatus: 0,
  existingTrackData: [],
  existingRefStems: [],
  existingStems: [],
  trackStatus: "",
  currentTrackId: 0,
  currentFinishedTrack: "",
  currentFinalStem: "",
  remixData: [],
  currentElement: "",
  currentMix: "",
  currentDataList: [],
  currentRefList: [],
  uploadProgress: 0,
  approved: 0,
};

export const mutations = {
  ADD_FILE(state, file) {
    state.fileList.push(file);
  },

  REMOVE_REF_FILE(state, { fileName }) {
    for (var i = 0; i < state.currentRefList.length; i++) {
      if (state.currentRefList[i].file.name === fileName) {
        state.currentRefList.splice(i, 1);
        break;
      }
    }
  },
  CLEAR_REF_FILE(state) {
    state.currentRefList = []
  },
  REMOVE_TRACK_FILE(state, { fileName }) {
    for (var i = 0; i < state.currentDataList.length; i++) {
      if (state.currentDataList[i].file.name === fileName) {
        state.currentDataList.splice(i, 1);
        break;
      }
    }
  },
  SET_MIXTYPE(state, mixType) {
    state.mixType = mixType;
  },
  CURRENT_ELEMENT(state, element) {
    state.currentElement = element;
  },
  CURRENT_MIX(state, mix) {
    state.currentMix = mix;
  },
  CURRENT_DATA(state, data) {
    state.currentDataList.push(data);
  },
  CURRENT_REF(state, data) {
    state.currentRefList.push(data);
  },
  ADD_ELEMENT(state, element) {
    if (!state.elementList.includes(element)) {
      state.elementList.unshift(element);
    }
  },
  SET_TRACK_NAME(state, trackName) {
    state.trackName = trackName;
  },
  SET_TRACK_CATEGORY(state, trackCategory) {
    state.trackCategory = trackCategory;
  },
  SET_TRACK_STATUS(state, status) {
    state.trackStatus = status;
  },
  SET_TRACK_STYLE(state, trackStyle) {
    state.trackStyle = trackStyle;
  },
  SET_USER_NAME(state, userName) {
    state.userName = userName;
  },
  SET_APPROVE_STATUS(state, status) {
    state.approved = status;
  },
  SET_CURRENT_TRACK_ID(state, trackId) {
    state.currentTrackId = trackId;
  },
  SET_CURRENT_FINAL_STEM(state, finalStem) {
    state.currentFinalStem = finalStem;
  },
  UPDATE_PROGRESS(state, { group, fileName, progress }) {
    let t = -1,
      f;
    for (var i = 0; i < state.fileList.length; i++) {
      if (
        state.fileList[i][1].name === fileName.name &&
        state.fileList[i][0] == group
      ) {
        t = i;
        f = state.fileList[i][1];
        break;
      }
    }
    if (t != -1) {
      state.fileList.splice(t, 1, [group, f, progress]);
    }
  },
  SET_TRACK_UPLOADING(state, { status }) {
    //state.trackUploadStatus.splice(0, 1, status);
    state.trackUploadStatus = status;
  },

  SET_ALL_TRACK_DATA(state, { trackId }) {
    for (let t of store.state.apiEvents.userTracks) {
      if (t.id == trackId) {
        t;
        state.trackName = t.trackname;
        state.trackCategory = t.category;
        state.trackStyle = t.style;
        state.mixType = t.mixids;
        state.currentTrackId = t.id;
        state.trackStatus = t.status;
        state.reqReuplaod = t.reupload_req;
        state.approved = t.approved;
      }
    }

    //state.trackProject = trackProject;
  },
  SET_PROGRESS(state, { progress }) {
    state.uploadProgress = progress;
  },
  CLEAR_ALL_TRACK_DATA(state) {
    state.trackName = "";
    state.trackCategory = "";
    state.trackStyle = "";
    state.mixType = "";
    state.elementList.splice(0, state.elementList.length);
    state.trackStatus = "";
    state.fileList.splice(0, state.fileList.length);
    state.currentTrackId = 0;
    state.existingTrackData.splice(0, state.existingTrackData.length);
    state.currentFinishedTrack = "";
    state.remixData = [];
    state.currentDataList = [];
    state.currentRefList = [];
    state.trackProject = "";
  },
  SET_NEW_TRACK_DATA(state, { trackName, trackCategory, trackStyle, trackId }) {
    state.trackName = trackName;
    state.trackCategory = trackCategory;
    state.trackStyle = trackStyle;
    state.currentTrackId = trackId;
    //  state.trackProject = $store.apiEvents.userProjects[0];
  },
  SET_NEW_TEMP_TRACK_DATA(state, { trackCategory, trackStyle }) {
    if (trackCategory) {
      state.trackCategory = trackCategory;
    }
    if (trackStyle) {
      state.trackStyle = trackStyle;
    }
  },
  SET_EXISTING_TRACK_REF(state, stems) {
    state.existingRefStems = stems;
  },
  SET_EXISTING_TRACK_STEMS(state, stems) {
    state.existingStems = stems;
  },
  SET_FINISHED_TRACKS(state, finishedTrack) {
    state.currentFinishedTrack = finishedTrack;
  },
  SET_REMIX_DATA(state, { data, type }) {


    if (data) {
      state.remixData = [...data];
    }


  },

  UPDATE_REMIX_DATA(state, { data, type }) {
    if (state.remixData) {
      state.remixData = [...state.remixData, ...data]
    } else {
      state.remixData = [...data]
    }
  },

  BLANK_COMMIT(state) {
    state;
  },
};

export const actions = {
  addFile({ commit }, file) {
    commit("ADD_FILE", file);
  },
  removeRefFile({ commit }, { fileName }) {
    commit("REMOVE_REF_FILE", { fileName });
  },
  clearRefFile ({commit}) {
    commit("CLEAR_REF_FILE")
  },
  removeTrackFile({ commit }, { fileName }) {
    commit("REMOVE_TRACK_FILE", { fileName });
  },
  setMixType({ commit }, mixType) {
    commit("SET_MIXTYPE", mixType);
  },
  currentElement({ commit }, element) {
    commit("CURRENT_ELEMENT", element);
  },
  currentMix({ commit }, mix) {
    commit("CURRENT_MIX", mix);
  },
  currentData({ commit }, data) {
    commit("CURRENT_DATA", data);
  },

  currentRef({ commit }, data) {
    commit("CURRENT_REF", data);
  },
  addElement({ commit }, element) {
    commit("ADD_ELEMENT", element);
  },
  setTrackName({ commit }, trackName) {
    commit("SET_TRACK_NAME", trackName);
  },
  setUserName({ commit }, userName) {
    commit("SET_USER_NAME", userName);
  },
  updateProgress({ commit }, { group, fileName, progress }) {
    commit("UPDATE_PROGRESS", { group, fileName, progress });
    return state.fileList.find(
      (file) => file[0] == group && file[1].name == fileName
    );
  },
  setTrackUploadStatus({ commit }, status) {
    commit("SET_TRACK_UPLOADING", status);
  },
  setTrackStatus({ commit }, status) {
    commit("SET_TRACK_STATUS", status);
  },
  setCurrentTrackId({ commit }, trackId) {
    commit("SET_CURRENT_TRACK_ID", trackId);
  },
  setAllTrackData({ commit }, { trackId }) {
    commit("SET_ALL_TRACK_DATA", {
      trackId,
    });
  },
  clearAllTrackData({ commit }) {
    commit("CLEAR_ALL_TRACK_DATA");
  },
  setRefStemElements({ commit }, trackId) {
    APIService.getrefsteminfo(trackId).then((response) => {
      commit("SET_EXISTING_TRACK_REF", response.data[0]);
    });
  },
  setexistingStems({ commit }, trackId) {
    APIService.getsteminfo(trackId).then((response) => {
      commit("SET_EXISTING_TRACK_STEMS", response.data[0]);
    });
  },
  updateProgress({ commit }, progress) {
    commit("SET_PROGRESS", { progress });
  },
  createNewTrack(
    { commit },
    {
      userId,
      trackName,
      projectId,
      trackCategory,
      trackStyle,
      trackProject,
      username,
      trackFiles,
      refFiles,
      elementGroup,
    }
  ) {
    return APIService.postNewTrack(
      userId,
      trackName,
      projectId,
      trackCategory,
      trackStyle,
      trackProject,
      username,
      trackFiles,
      refFiles,
      elementGroup
    ).then((response) => {
      console.log(response);
      commit("CLEAR_ALL_TRACK_DATA");
      commit("SET_NEW_TRACK_DATA", {
        trackName,
        trackCategory,
        trackStyle,
        // trackId,
        trackProject,
      });
      return response;
    });
  },
  setTempTrackData(
    { commit },
    { trackName, trackCategory, trackStyle, trackId }
  ) {
    commit("SET_NEW_TEMP_TRACK_DATA", {
      trackName,
      trackCategory,
      trackStyle,
      trackId,
    });
  },
  fetchFinshedTracksByTrackId({ commit }, trackId) {
    return APIService.getFinishedTracksByTrackId(trackId).then((response) => {
      if (response.data[0][0] != null) {
        commit("SET_FINISHED_TRACKS", response.data[0][0].trackurl);
      }
    });
  },
  fetchFinalStemByTrackId({ commit }, trackId) {
    return APIService.getFinalStemByTrackId(trackId).then((response) => {
      if (response.data[0][0] != null) {
        commit("SET_CURRENT_FINAL_STEM", response.data[0][0].trackurl);
      }
    });
  },
  fetchRemixesByTrackId({ commit }, trackId) {
    return APIService.getRemixesByTrackId(trackId).then((response) => {
      if (response.data[0] != null) {
        console.log('fetch remixes', response.data);
        commit("SET_REMIX_DATA", response.data || []);
      }
    });
  },
  setUpdateRemixData({ commit }, { data, type }) {
    commit("UPDATE_REMIX_DATA", {
      data: data,
      type: type,
    });
  },
  sendRemixData({ commit }, { trackid }) {
    commit("BLANK_COMMIT");
    // let joinMethod = (array) => {
    //   let a = [];
    //   for (let o of array) {
    //     a.push(o[1] + ": " + o[2]);
    //   }
    //   return a.join(", ");
    // };
    // for (let u of state.remixData)
    //   if (re.indexOf(u[0]) == -1) {
    //     re.push(u[0]);
    //     rs.push(
    //       joinMethod(
    //         state.remixData.filter((value) => {
    //           return value[0] == u[0];
    //         })
    //       )
    //     );
    //   }

    // return APIService.postNewRemix(
    //   trackid,
    //   state.trackName,
    //   state.remixData,
    //   localStorage.getItem("userId"),
    // );
  },
};

export const getters = {
  getProgressByKey: (state) => (group, fileName) => {
    return state.fileList.find(
      (file) => file[0] == group && file[1].name == fileName
    );
  },
  // getFileList: state => {
  //   return state.fileList;
  // },
  // getMixType: state => {
  //   return state.mixType;
  // }
  // getElementList: state => {
  //   return state.elementList;
  // }
};
